'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_RELATIVE_URL = exports.BASE_RELATIVE_URL = '/_hcms/mem/';

exports.default = {
  LOGIN_URL: BASE_RELATIVE_URL + 'login/verify',
  REGISTER_URL: BASE_RELATIVE_URL + 'register/verify',
  RESET_URL: BASE_RELATIVE_URL + 'reset/verify',
  PASSWORD_URL: BASE_RELATIVE_URL + 'password/verify'
};


//////////////////
// WEBPACK FOOTER
// ./js/constants/urls.js
// module id = 8
// module chunks = 0 1 2